module.exports = __webpack_public_path__ + "static/media/bernard-gersh.91ed4860.jpg";